import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { styled } from '@mui/styles';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '25rem',
        maxWidth: '32rem',
      },
}));

interface ModalNotificationChoiceProps {
  open: boolean;
  onClose: (open: boolean) => void;
  onManual: () => void;
  onDigital: () => void;
}

const ModalNotificationChoice = ({
  open,
  onClose,
  onManual,
  onDigital,
}: ModalNotificationChoiceProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      <DialogContent style={{ padding: '30px 24px' }}>
        Si vuole procedere con la notifica manuale o digitale(Send)?
      </DialogContent>
      <DialogActions>
        <PmiButton
          variant="outlined"
          color="cdmBrandThird"
          type="button"
          onClick={() => onManual()}
        >
          Notifica manuale
        </PmiButton>
        <PmiButton
          variant="outlined"
          color="cdmBrandThird"
          type="button"
          onClick={() => onDigital()}
        >
          Notifica digitale
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrand" type="button" onClick={() => onClose(false)}>
          Annulla
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalNotificationChoice.displayName = 'Modal Notification Choice';

export default ModalNotificationChoice;
